import { format } from 'date-fns';

import { DATE_FORMATS } from '@constants/general';

/**
 * Formats date into correct string for API
 */
export const formatRegApiDate = (date?: Date) => {
  try {
    if (!date) return undefined;
    return format(date, DATE_FORMATS.REG_PAGE.DATE_FORMAT);
  } catch (e) {
    return undefined;
  }
};
